import { render, staticRenderFns } from "./RetoureShelf.vue?vue&type=template&id=39c76de6&scoped=true"
import script from "./RetoureShelf.vue?vue&type=script&lang=js"
export * from "./RetoureShelf.vue?vue&type=script&lang=js"
import style0 from "./RetoureShelf.vue?vue&type=style&index=0&id=39c76de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c76de6",
  null
  
)

export default component.exports